import { render, staticRenderFns } from "./Alertbusiness.vue?vue&type=template&id=3d6956fd&"
import script from "./Alertbusiness.vue?vue&type=script&lang=ts&"
export * from "./Alertbusiness.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports